import { render, staticRenderFns } from "./SupplierCommittedTimberPanels.vue?vue&type=template&id=02826ade&"
import script from "./SupplierCommittedTimberPanels.vue?vue&type=script&lang=js&"
export * from "./SupplierCommittedTimberPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports